<template>
    <div class="location">
        <div class="map" id="map"></div>
        <div :class="[status=='离线'?'top-long location-electric':'location-electric']">
          <div class="electric-num">
              <span :style="{'width': (electric/100*89)+'%'}"></span>
          </div>
          <p>{{electric}}%</p>
        </div>
        <div v-if="status=='离线'" class="no-network" @click="noNetwork=true">
            <div class="link-box">
              <img class="link-img" src="@/assets/images/link.png" background-size="cover" />
              <span class="link-test">设备当前未连接网络</span>
            </div>
            <div class="arrows"></div>
        </div>
        <div :class="[status=='离线'?'top-long location-control':'location-control']">
            <div class="control-box">
                <img class="control-img" src="@/assets/images/road.png" background-size="cover" @click="switchMapTraffic" />
                <p>路况</p> 
            </div>
            <span></span>
            <div class="control-box">
                <img class="control-img" src="@/assets/images/coverage.png" background-size="cover" @click="switchMapType" />
                <p>图层</p> 
            </div>
        </div>
        <!-- <div class="water-safety">
          <img class="water-img" src="@/assets/images/coverage.png" background-size="cover" @click="toWaterSafety" />
        </div> -->
        <div class="location-scale">
            <img class="scale-img" src="@/assets/images/add.png" background-size="cover" @click="switchMapZoom(1)" />
            <img class="scale-subtract" src="@/assets/images/subtract.png" background-size="cover" @click="switchMapZoom(-1)" />
        </div>
        <div class="location-phone" v-if="!disableDevice">
          <img @click="show=true|getDeviceList()|getSupportList()" class="phone-img" src="@/assets/images/phone.png" background-size="cover" />
        </div>
        <div v-if="serviceFlag" class="location-phone location-service">
          <img @click="toService" class="phone-img" src="@/assets/images/qg_service.png" background-size="cover" />
        </div>
        <div class="location-card">
          <div class="card-top">
              <p>{{devicename}}</p>
              <div :class="[status==='在线'?'online device-state':'offline device-state']">{{status}}</div>
          </div>
          <div class="card-bottom">
            <div class="card-information" v-if="!disableDevice">
              <div class="information-type">
                  <img class="information-img" :src="imgStatus[locType]" />
                  <p class="card-icon">{{textStatus[locType]}}</p>
                  <p v-show="!!createDate || createDate!=''">更新于  <span style="color: #999999;">{{createDate}}</span></p>
              </div>
              <div class="information-address">
                  <img class="information-img" src="@/assets/images/pieces.png" background-size="cover" />
                  <p>{{addr}}</p>
              </div>
            </div>
            <div v-else class="card-disableDevice">
              <p>当前设备已禁用，请联系服务商进行处理；</p>
            </div>
            <div class="card-refresh" @click="refreshLocation">
              <img :class="[needSpin?'information-img spin-infinte':'information-img']" src="@/assets/images/refresh.png" background-size="cover" />
              <p>更新位置 </p>
            </div>
          </div>
        </div>
        <van-popup v-model="show" position="bottom" closeable round @close="onClose">
        <div class="pop-content">
            <div v-if="callRecode" class="device-title" style="justify-content: space-between;">
            <!-- <span>请选择拨号联系人</span> -->
              <span style="margin-left:20px;">请选择拨号联系人</span>
              <span style="margin-right:20px;font-weight:100;" @touchstart="toCalllog">通话记录 ></span>
            </div>
            <div v-else class="device-title" style="justify-content: center;">
              <span>请选择拨号联系人</span>
            </div>
            <div class="auto-box">
                <div class="no-data-center" v-if="!deviceList">
                通讯录暂无号码
                </div>
                <div class="device-information" v-else>
                    <div class="device-name">
                    <img class="information-img" src="@/assets/images/morentouxiangbeifen.png" background-size="cover" />
                    <p>{{deviceList.name}}</p>
                    </div>
                    <div class="device-phone"  @click="onfillNum(deviceList)">
                    <p>{{deviceList.sim?deviceList.sim:'未设置号码'}}</p>
                    <img @click.stop="callThisnum(deviceList)" class="information-img" :src="(deviceList.sim&&deviceList.sim.length>0)?require('@/assets/images/telephone-active.png'):require('@/assets/images/telephone.png')" background-size="cover" />
                    </div>
                </div>
            </div>
        </div>
        </van-popup>
        <van-popup class="need-top" v-model="fillNum" round @close="closeFill">
        <div class="fill-number">
            <img class="fill-img" src="@/assets/images/fill_number.png" />
            <p>设置手机号码</p>
            <van-field
            v-model="value"
            placeholder="请输入手机号"
            :border="true"
            type="number"
            maxlength="11"
            />
            <div class="fill-btn">
            <van-button class="fill-cancel" type="primary" @click="closeFill">取消</van-button>
            <van-button class="fill-confirm" type="primary" @click="setPhone">确定</van-button>
            </div>
        </div>
        </van-popup>
        <div v-if="noNetwork" class="network-box" @close="closeNetwork">
        <div class="h-bgc">
            <img class="no-network-img" src="@/assets/images/no_network.png" />
            <b>设备未连接网络</b>
            <p>请先检查设备当前是否存在以下问题:</p>
            <span>未插SIM卡或者SIM卡未插好、关机、欠费、处于弱信号环境；</span>
            <p>您也可以拨打设备电话进行尝试</p>
            <div class="network-btn">
            <van-button class="network-cancel" type="primary" @click.stop="closeNetwork">我知道了</van-button>
            </div>
        </div>
        </div>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/lib/common'; //有效值验证
export default {
    name: 'location',
    data() {
        return {
          disableDevice:false,//是否禁用
          electric: 0,//电池电量
          devicename:'无',
          mapHeight: 'auto',
          show:false,//拨打设备电话
          noNetwork:false,//无网络连接
          serviceFlag:false,
          fillNum:false,//填写号码
          createDate:'',//更新定位时间
          locType:'3',//定位类型0 GPS 1 WIFI 2 LBS
          addr:'暂未获取到最新位置',//定位地址
          imgStatus:{ //定位类型
              '2':require('@/assets/images/lbs.png'),
              '0':require('@/assets/images/gps.png'),
              '1':require('@/assets/images/wifi.png'),
              '3':require('@/assets/images/wifi.png')
          },
          textStatus:{ //定位类型
              '2':'基站定位',
              '0':'卫星定位',
              '1':'WIFI定位',
              '3':'无'
          },
          status:'在线',//是否在线
          deviceList:null,//设备电话列表
          value:'',//设置手机号码
          updateImei:'',//设置号码时存个imei
          locationArray:[],//设备点信息集合
          needSpin:false,//是否需要旋转

          /* 地图参数配置 */
          mapConfig: {
              map: null, //地图
              point: null, //坐标点
              userMarker: null, //用户标记
              circle:null, //圆
              mapType: false, //地图展示类型，false为2D，true为3D,
              traffic: {
                  ctrl: null, //控制器
                  status: false //交通信号显示
              },
              customOverlay: null //自定义遮盖物，用户图标头顶的地址气泡
          },
          locationInfoData: null, //定位接口数据
          weTimeOut:null,//定位后定时请求
          callRecode:false,//是否显示通话记录
        };
    },
    created() {
        this.updateData().then(() => {
            this.setCenterAndZoom();
        });
        this.updateCustomOverlay();
        this.refreshLocation()
    },
    mounted() {
        this.initMap();
    },
    computed: {
        point() {
            return this.mapConfig.point;
        }
    },
    methods: {
      //跳转通话记录
    toCalllog(){
      this.$router.push({ name: 'callLog' });
    },
      /**
     * 获取设备支持的指令列表
     */
    getSupportList(){
      let data = {
        ver:1,
        method:'getDeviceAllInfo'
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.$store.commit('set_devTypeList', JSON.stringify(res.data.instructionList));
            this.callRecode = res.data.instructionList.some(item=>item.name==='通话记录')
          } else {
            wx.showToast({
              title: res.msg,
              icon: "none"
            });
          }
      })
    },
      /**
        跳转去客服页面
        */
      toService(){
        this.$router.push({name:'service'})
      },
        /**
        跳转去水域安全页面
        */
        toWaterSafety(){
          this.$router.push({name:'waterSafety'})
        },
        /**
         * 定时器打开
         */
        timerOpen() {
          let that = this;
            this.weTimeOut = window.setTimeout(() => {
              that.updateData().then(() => {
                that.setCenterAndZoom();
              });
            }, 10000);
        },
        /**
         * 开启关闭无连接提示
         */
        closeNetwork(){
        this.noNetwork = false
        },
        /**
         * 初始化地图
         */
        initMap() {
            const that = this,
            point = new BMap.Point(116.404, 39.915),
            map = this.mapConfig.map = new BMap.Map('map');

            this.addMapTraffic();
            map.centerAndZoom(point, 15);
            map.enableScrollWheelZoom();
            map.addEventListener( "zoomstart" , (evt)=>{
              console.log(77,that.mapConfig.point)
              var num = map.getZoom()
              console.log(num,55,map)
              // that.mapConfig.map.zoomTo(num);
              // var  cp = map.getCenter();   alert(cp.lng +  ","  + cp.lat);
              that.mapConfig.map.centerAndZoom(that.mapConfig.point,num); 
              // that.mapConfig.map.centerAndZoom("北京"); 
              // that.mapConfig.map.setCenter(that.mapConfig.point)
            });
        },
        /**
         * 创建标记
         * @param {Object} options 配置文件
         * @param {Object} options.latLng  坐标
         * @param {Object} options.icon  图标
         * @param {Stirng} options.icon.url 图标地址
         * @param {Object} options.icon.size 图标大小
         * @param {Object} options.icon.imageSize 图标背景大小
         * @param {Object} options.icon.anchor 图标背景偏移量
         */
        createMarker(options) {

            /* 默认配置 */
            const defaults = {
                latLng: {
                    lng: 116.404,
                    lat: 39.915
                },
                icon: {
                    url: '',
                    size: {

                        width: 40,
                        height: 55
                    },
                    imageSize: {
                        width: 40,
                        height: 55
                    },
                    anchor: {
                        x: 20,
                        y: 27
                    }
                }
            };
            const settings = _.merge({}, defaults, options); //合并配置

            /* 创建图标 */
            const icon = new BMap.Icon(
                settings.icon.url,
                new BMap.Size(settings.icon.size.width, settings.icon.size.height),
                {
                    anchor: new BMap.Size(settings.icon.anchor.x, settings.icon.anchor.y),
                    imageSize: new BMap.Size(settings.icon.imageSize.width, settings.icon.imageSize.width)
                }
            );
            /* 创建坐标点 */
            const point = new BMap.Point(settings.latLng.lng, settings.latLng.lat);

            /* 创建标记 */
            const marker = new BMap.Marker(point, {
                icon: icon
            });

            /* 绑定点击事件 
            marker.addEventListener('click', () => {
                this.addCustomOverlay();
                this.updateMackerIcon();
            })
            */

            return marker;
        },
        /**
         * 添加圆形
         * @param {Object} point 点坐标
         * @param {Number} radius 半径
         */
        addCircle(point, radius) {
            let circle = new BMap.Circle(point, radius, {
                strokeColor: '#0067B5',
                strokeWeight: 1,
                fillOpacity: 0.4,
                fillColor: '#0067B5',
                strokeOpacity: 0.2
            });
            return circle; // 返回圆形的实例
        },
        /**
         * 更新marker标记
         */
        updateMarker() {
            let { userMarker, point } = this.mapConfig;
            if (userMarker) {
                this.mapConfig.userMarker.setPosition(point);
                return;
            }

            /* 创建用户标记 */
            this.mapConfig.userMarker = this.createMarker({
                latLng: point,
                icon: {
                    url: require('@/assets/images/icon_boy_1.png'),
                    size: {
                        width: 135,
                        height: 135
                    },
                    imageSize: {
                        width: 135,
                        height: 135
                    },
                    anchor: {
                        x: 67,
                        y: 67
                    }
                }
            });
            // let icon = new BMap.Icon(require('@/assets/images/icon_boy.png'), new BMap.Size(40, 40), {
            //     imageSize: { width: 40, height: 40 } // 图片大小
            // });
            // this.mapConfig.userMarker = new BMap.Marker(point, { icon: icon })

            // this.mapConfig.circle = this.addCircle(point, 200); // 创建圆形覆盖物
            /* 标记添加到地图 */
            this.mapConfig.map.addOverlay(this.mapConfig.userMarker);
            // this.mapConfig.map.addOverlay(this.mapConfig.circle);
        },

        /**
         * 地图放大缩小切换
         * param {Number} num 地图增加或减少的层级
         */
        switchMapZoom(num) {
            if (Number.isNaN(Number(num))) {
                //如果不能转换为数字则不往后运行
                return false;
            }
            let zoom = this.mapConfig.map.getZoom() + num;
            this.mapConfig.map.zoomTo(zoom);
        },

        /**
         * 设置地图标记居中及缩放级别
         * param {Object} point 地图坐标点Point对象，默认值为孩子坐标点
         * param {Number} zIndex 地图缩放层级，默认值为15
         */
        setCenterAndZoom(point, zIndex) {
            this.mapConfig.map.centerAndZoom(point || this.mapConfig.point, zIndex || 16);
        },
        /**
         * 地图图层类型切换
         */
        switchMapType() {
            this.mapConfig.mapType = !this.mapConfig.mapType;

            if (this.mapConfig.mapType) {
                this.mapConfig.map.setMapType(BMAP_HYBRID_MAP);
            } else {
                this.mapConfig.map.setMapType(BMAP_NORMAL_MAP);
            }
        },
        /**
         * 交通信号图层切换
         */
        switchMapTraffic() {
            this.mapConfig.traffic.status = !this.mapConfig.traffic.status;

            if (this.mapConfig.traffic.status) {
                this.mapConfig.traffic.ctrl.showTraffic();
            } else {
                this.mapConfig.traffic.ctrl.hideTraffic();
            }
        },
        /**
         * 设置交通路况
         */
        addMapTraffic() {
            const ctrl = this.mapConfig.traffic.ctrl = new BMapLib.TrafficControl({
                showPanel: false //是否显示路况提示面板
            });

            ctrl.setAnchor(BMAP_ANCHOR_BOTTOM_RIGHT);
            this.mapConfig.map.addControl(ctrl);
        },

        /**
         * 设置地图最佳视角
         * @param {Array} points 坐标点数组
         */
        setBestViewport(points) {
            const view = this.map.getViewport(points); //获取最佳视角
            const zoom = view.zoom - 1; //获取最佳视角的缩放层级，减1更好适配边界问题
            const centerPoint = view.center; //获取最佳视角的中心点
            this.map.centerAndZoom(centerPoint, zoom); //设置中心点和缩放层级
        },

        /**
         * 更新自定义覆盖物
         */
        updateCustomOverlay() {
            console.log(this.mapConfig.customOverlay,"更新自定义覆盖物")
            if (this.mapConfig.customOverlay && this.mapConfig.customOverlay._visible) {
                this.mapConfig.customOverlay.setContent(this.locationInfoData.addr, this.mapConfig.point);
            }
        },

        /**
         * 请求后端轨迹接口数据
         */
        updateData() {
            const that = this;
            let data = {
                ver:1,
                method:'getLocationInfo',
                // showLoading: false 
            }
            return this.$http.get(this.$api.userInfo.POST_APPLET, data).then(resolve => {
                if (resolve.code === 0) {
                    this.needSpin = false;
                    if (!isEmpty(resolve.data.locationInfo)) {
                        document.title = resolve.data.header;
                        this.devicename = resolve.data.device.deviceName
                        this.createDate = resolve.data.locationInfo.gpsTime
                        this.addr = resolve.data.locationInfo.addr
                        this.locType = resolve.data.locationInfo.locType
                        this.disableDevice = resolve.data.locationInfo.status === "arrears"
                        this.electric = resolve.data.locationInfo.percentageElectricQuantity
                        this.status = resolve.data.locationInfo.status==="online"?'在线':resolve.data.locationInfo.status==="arrears"?'禁用':'离线'
                        that.locationInfoData = resolve.data.locationInfo;
                        this.serviceFlag = resolve.data.customerMenu=="1"

                        // let curDate = (new Date(resolve.data.locationInfo.gpsTime)).getTime();
                        // let tmieframe = 180 * 1000;
                        // let tmieDifference = Date.now() - curDate;
                        // console.log(curDate,tmieDifference,259)
                        // if(tmieDifference>tmieframe){
                        //   this.refreshLocation()
                        // }
                        that.updatePoint();
                    } else {
                        that.$toast('定位数据为空');
                    }
                } else {
                    this.needSpin = false;
                    that.$toast({
                        message: resolve.msg,
                        icon: 'close'
                    });
                }

            }, reject => {
                reject && that.$toast({
                    message: reject.message,
                    icon: 'close'
                });
            })
        },
        /**
        * 更新坐标点数据
        */
        updatePoint() {
            this.mapConfig.point = new BMap.Point(this.locationInfoData.longitude, this.locationInfoData.latitude);
        },




        /**
         * 获取设备列表号码
         */
        getDeviceList(){
        let data = {
            ver:1,
            method:'getDeviceInfo'
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.deviceList = res.data
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: 'close'
                });
            }
        })
        },
        //关闭设备电话选项
        onClose(){
        this.show=false;
        },
        //关闭填写号码
        closeFill(){
        this.fillNum=false;
        },
        //是否设置了号码
        onfillNum(val){
          this.updateImei = val.imei
          this.fillNum = true
        },
        //拨打号码
        callThisnum(val){
          if(val.sim && val.sim.length>0){
            window.location.href = "tel:"+val.sim;
          }else{
            this.updateImei = val.imei
            this.fillNum = true
          }
        },
        //设置号码
        setPhone(){
            let that = this;
            if(this.value.length!==11){
                that.$toast("请输入正确的手机号码")
            }
            let data = {
                ver:1,
                method:'updateDevice',
                sim:this.value,
                imei:this.updateImei
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.value = ""
                    that.$toast({
                        message: '添加成功',
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/correct.png'),
                    });
                    this.getDeviceList()
                    this.fillNum=false;
                } else {
                    this.value = ""
                    that.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: 'close'
                    });
                    this.fillNum=false;
                }
            })
        },
        /**
         * 更新定位
         */
        refreshLocation(){
          if(this.disableDevice){
            this.$toast({
              message: '设备当前已禁用，请联系服务商开通处理',
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
            return
          }
        this.needSpin = true
        let that = this;
        let data = {
            ver:1,
            method:'sendImmediateLocation',
            // instructionId:instructFilter('立即定位')
        }
        this.$http.get(this.$api.userInfo.POST_APPLET, data).then(res => {
            if (res.code === 0) {
                let timer = setTimeout(()=>{
                    that.updateData().then(() => {
                        that.needSpin = false; //结束请求动画
                        that.setCenterAndZoom();
                        that.updateCustomOverlay();
                    });
                    clearTimeout(timer)
                },1000)
                this.timerOpen()
                that.$toast({
                    message: '正在为您更新最新位置',
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/correct.png'),
                });
            } else {
                that.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: 'close'
                });
            }
        });
        },

    },
    watch: {
        /* 坐标点更新响应 */
        point: {
            handler: function (val) {
                this.updateMarker();
                this.updateCustomOverlay();
            },
            deep: true//深度监听
        }
    },
    beforeDestroy() {
      window.clearInterval(this.weTimeOut);
      this.weTimeOut = null
    }
};
</script>

<style lang="scss" scoped>
@keyframes rotate1 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.location{
    height: 100%;
    .map {
        height: 100%;
    }
}
.spin-infinte{
  animation: 0.8s rotate1 cubic-bezier(0, 0, 0, 0) infinite;
}
.location-electric{
  width: 84px;
  height: 84px;
  position: absolute;
  top: 90px;
  left: 20px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
}
.location-electric>p{
  font-size: 24px;
  font-weight: 400;
  color: #111111;
}
.location-electric .electric-num{
  width: 35px;
  height: 20px;
  border: 1px solid #4ED964;
  border-radius: 5px;
  position: relative;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  padding: 0 2px;
}
.location-electric .electric-num::after{
  content: "";
  position: absolute;
  width: 2px;
  height: 5px;
  background-color: #4ED964;
  right: -4px;
  top: 9px;
}
.location-electric .electric-num>span{
  position: absolute;
  height: 80%;
  background-color: #4ED964;
}
.no-network{
  position: absolute;
  top: 0;
  z-index: 5;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FC4D56;
  height: 75px;
  color: #fff;
}
.no-network .link-img{
  width: 40px;
  height: 40px;
  margin-right: 20px;
}
.no-network .link-box{
  display: flex;
  align-items: center;
}
.no-network .link-test{
  font-size: 24px;
  font-weight: 400;
}
.arrows{
  width: 15px;
  height: 15px;
  transform:rotate(45deg);
  border-top: 3px solid #fefdfe;
  border-right: 3px solid #fefdfe;
  margin-right: 36px;
}
.location-control{
  width: 84px;
  height: 200px;
  position: absolute;
  top: 90px;
  right: 20px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
}
.location-control>span{
  display: flex;
  width: 54px;
  height: 1px;
  background: #E5E5E5;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
}
.location-control .control-box{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.location-control .control-box .control-img{
  width: 46px;
  height: 46px;
}
.location-control .control-box>p{
  font-size: 18px;
  font-weight: 400;
  color: #111111;
  text-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
}
.water-safety{
  width: 84px;
  height: 84px;
  position: absolute;
  bottom: 730px;
  right: 20px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
}
.water-safety .water-img{
  width: 68px;
  height: 68px;
}
.location-scale{
  width: 84px;
  height: 162px;
  position: absolute;
  bottom: 630px;
  right: 20px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
}
.location-scale .scale-img{
  width: 72px;
  height: 72px;
}
.location-scale .scale-subtract{
  width: 72px;
  height: 43px;
} 
.location-phone{
  width: 84px;
  height: 84px;
  position: absolute;
  bottom: 530px;
  right: 20px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
  &.location-service{
    bottom: 430px;
  }
}
.location-phone .phone-img{
  width: 44px;
  height: 44px;
}
.location-card{
  width: 690px;
  height: 282px;
  position: absolute;
  bottom: 75px;
  left: 30px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
  padding: 0 32px;
}
.location-card .card-top{
  width: 100%;
  display: flex;
  align-items: center;
  padding: 25px 0;
  border-bottom: 1px solid #E5E5E5;
}
.location-card .card-top>p{
  font-size: 36px;
  font-weight: 600;
  color: #111111;
  margin-right: 28px;
}
.location-card .card-top .device-state{
  font-size: 24px;
  font-weight: 500;
  width: 80px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-top-left-radius:20px;
  border-top-right-radius:20px;
  border-bottom-right-radius:20px;
}
.location-card .card-top .online{
  color: #FFFFFF;
  background-color: #4ED964;
}
.location-card .card-top .offline{
  background: #C2C2C2;
  color: #FFFFFF;
}
.location-card .card-bottom{
  flex: 1;
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-size: 24px;
}
.location-card .card-bottom .card-disableDevice{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
}
.location-card .card-bottom .card-disableDevice>p{
  font-size: 26px;
}
.location-card .card-bottom .card-information{
  flex: 1;
  display: flex;
  flex-direction: column;
  color: #666666;
}
.location-card .card-bottom .card-information>div{
  display: flex;
}
.location-card .card-bottom .card-information .card-icon{
  margin-right: 30px;
}
.card-information .information-type{
  margin: 35px 0 10px 0;
}
.information-address{
 
}
.information-address>p{
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
.location-card .card-bottom .card-information .information-img{
  width: 36px;
  height: 36px;
  margin-right: 10px;
}
.card-refresh {
  width: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.card-refresh>p{
  font-weight: 600;
  color: #111111;
}
.card-refresh .information-img{
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}
.location .pop-content{
  background-color: #fff;
  position: relative;
}
.location .pop-content .device-title{
  // position: absolute;
  background-color: #fff;
  width: 100%;
  text-align: center;
  // top: 0;
  font-size: 30px;
  font-weight: 500;
  color: #111;
  display: flex;
  justify-content: center;
  padding: 40px 0 60px 0;
}
.auto-box{
  height: 250px;
  overflow: auto;
  // padding-top: 150px;
}
.no-data-center{
  line-height: 250px;
  text-align: center;
}
.location .pop-content  .device-information{
  font-size: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  padding: 0 60px;
  margin-bottom: 20px;
}
.device-information .device-name{
  display: flex;
  align-items: center;
}
.device-name>p{
  display: inline-block;
  width: 220px;
  overflow: hidden;
  text-overflow:ellipsis; 
  white-space: nowrap;
}
.device-information .device-name .information-img{
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
.device-information .device-phone{
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 28px;
}
.device-information .device-phone .information-img{
  width: 60px;
  height: 60px;
  margin-left: 30px;
}
.location .fill-number{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 32px 32px;
}
.fill-number>p{
  margin: 40px 0 3px;
  font-size: 36px;
  font-weight: 600;
  color: #111111;
}
.location .fill-number .fill-img{
  width: 356px;
  height: 192px;
}
.location .fill-number .fill-btn{
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.top-long{
  top: 120px;
}
.network-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.h-bgc{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  margin-top: 40px;
  width: 520px;
  position: relative;
  border-radius: 36px;
  padding: 0 40px;
}
.no-network-img{
  width: 308px;
  height: 294px;
  position: absolute;
  left: 50%;
  margin-left: -154px;
  top: -40px;
}
.network-box b{
  font-size: 34px;
  color: #111111;
  font-weight: 600;
  margin: 300px 0 30px;
}
.network-box p{
  font-size: 26px;
  color: #676767;
  margin-bottom: 10px;
}
.network-box .h-bgc>span{
  font-size: 26px;
  color: #666666;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}
.network-btn{
  display: flex;
  justify-content: center;
  margin: 40px 0;
}
</style>
<style>
.network-btn .van-button{
  width: 300px;
  height: 80px;
  border-radius: 50px;
  background: #01ada9;
  border: 2px solid #01ADA9;
  color: #FFFFFF;
}
.location .fill-number .van-button{
  width: 200px;
  height: 68px;
}
.location .van-popup__close-icon--top-right{
  /* top: 18px; */
  display: none;
}
.location .need-top .van-popup--round{
  top: 400px;
}
.location .fill-number .fill-cancel {
  margin-right: 36px;
  background: #FFFFFF;
  border-radius: 34px;
  color: #01ADA9;
  border: 2px solid #01ADA9;  
}
.location .fill-number .fill-confirm {
  background: #01ADA9;
  border-radius: 34px;
  border: 2px solid #01ADA9;
  color: #fff;
}
.location .fill-number .van-field__control{
  text-align: center;
}
</style>
